const links = [
  {
    id: "x",
    label: "X (Twitter)",
    description: "ライトな日常をつぶやいています。",
    url: "https://x.com/ikeunicloud",
    icon: "ri-twitter-x-line",
  },
  {
    id: "note",
    label: "note",
    description: "興味のある技術情報や考えなど発信中",
    url: "https://note.com/unicloud",
    icon: "ri-article-line",
  },
  {
    id: "homepage",
    label: "ホームページ",
    description: "サービス詳細やお問い合わせはこちら。",
    url: "https://ike-unicloud.com/",
    icon: "ri-global-line",
  },
];

export default function LinkSection() {
  return (
    <section id="links" className="relative w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-14 md:mb-18">
          <span className="inline-block font-label text-xs tracking-widest text-foreground-400 uppercase mb-3">
            Follow &amp; Connect
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-3">
            リンク一覧
          </h2>
          <p className="font-body text-sm md:text-base text-foreground-600 max-w-md mx-auto leading-relaxed">
            日々の活動や最新情報をSNSとホームページで発信中です。ぜひフォロー＆チェックしてみてください。
          </p>
        </div>

        <div className="flex flex-col gap-6 md:gap-8">
          {links.map((link, index) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group flex items-center gap-5 md:gap-7 p-6 md:p-8 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 cursor-pointer animate-fade-in-up`}
              style={{ animationDelay: `${0.15 + index * 0.1}s` }}
            >
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl bg-background-50 border border-background-300/60 flex-shrink-0 group-hover:bg-accent-100 group-hover:border-accent-300 transition-colors duration-300">
                <i className={`${link.icon} text-2xl md:text-3xl text-foreground-700 group-hover:text-accent-700 transition-colors duration-300`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-label text-base md:text-lg font-bold text-foreground-900 group-hover:text-foreground-950 transition-colors">
                  {link.label}
                </h3>
                <p className="font-body text-xs md:text-sm text-foreground-500 mt-1 whitespace-nowrap">
                  {link.description}
                </p>
              </div>
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center flex-shrink-0 rounded-full bg-background-200/70 group-hover:bg-accent-500 group-hover:text-white text-foreground-300 group-hover:translate-x-1 transition-all duration-300">
                <i className="ri-arrow-right-line text-lg md:text-xl"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}